// import { Capacitor } from "@capacitor/core";
// import { isNativePlatform } from "@/lib/capacitor";
import { getApiBaseUrlFromEnv } from "@/lib/env";

export function getApiBaseUrl(): string {
  const baseUrl = getApiBaseUrlFromEnv();

  // if (
  //   typeof window !== "undefined" &&
  //   isNativePlatform() &&
  //   Capacitor.getPlatform() === "android" &&
  //   (baseUrl.includes("localhost") || baseUrl.includes("127.0.0.1"))
  // ) {
  //   baseUrl = baseUrl
  //     .replace("localhost", "10.0.2.2")
  //     .replace("127.0.0.1", "10.0.2.2");
  // }

  return baseUrl.replace(/\/+$/, "");
}
